<div class="login">
  <h1>Forgot password?</h1>
  <form id="ResetPasswordForm" #resetPasswordForm="ngForm">
    <div class="form-group">
      <p>{{ enterLoginPrompt }}</p>
    </div>
    <div class="form-group">
      <input
        aria-label=""
        type="text"
        [(ngModel)]="loginEmailAddress"
        name="memo-answer"
        class="auth-input"
        placeholder="Login email address"
        id="txtForgotPasswordEmailAddress"
      />
    </div>
    <!-- <div class="form-group">
      <input aria-label=""  type="text" [(ngModel)]="memorableAnswer"
             name="memo-answer" class="auth-input" placeholder="Memorable answer">
    </div>
    <div class="form-group">
      <input aria-label=""  type="password" [(ngModel)]="newPassword"
             name="new-password" class="auth-input" placeholder="New password">
    </div>
    <div class="form-group">
      <input aria-label=""  type="password" [(ngModel)]="confirmPassword"
             name="confirm-password" class="auth-input" placeholder="Confirm password">
    </div> -->
    <div class="form-group text-right">
      <button type="submit" class="auth-submit" (click)="onSendResetLinkClick()" id="btnSendReset">
        {{ sendingStatus === true ? 'Sending...' : 'Send Reset Link' }}
      </button>
      <a class="forgot-link" [routerLink]="['/login']"> login </a>
    </div>
  </form>
</div>
